export type TopicListWarmChat = {
  id: string
  type: string
  archived?: boolean
  unread?: number | null
  queue_depth?: number | null
  active_work_depth?: number | null
  last_activity_at?: number | null
  created_at?: number | null
}

const BASE_TOPIC_LIST_WARM_LIMIT = 4
const IMPORTANT_TOPIC_LIST_WARM_LIMIT = 8

function chatActivity(chat: TopicListWarmChat): number {
  return chat.last_activity_at ?? chat.created_at ?? 0
}

function topicListWarmPriority(chat: TopicListWarmChat): number {
  let priority = 0
  if ((chat.active_work_depth ?? 0) > 0) priority -= 400
  if ((chat.queue_depth ?? 0) > 0) priority -= 300
  if ((chat.unread ?? 0) > 0) priority -= 200
  return priority
}

function shouldAlwaysWarmTopicList(chat: TopicListWarmChat): boolean {
  return (
    (chat.active_work_depth ?? 0) > 0 ||
    (chat.queue_depth ?? 0) > 0 ||
    (chat.unread ?? 0) > 0
  )
}

export function selectTopicListWarmTargets<T extends TopicListWarmChat>(chats: T[]): T[] {
  const candidates = chats
    .filter((chat) => !chat.archived && chat.type === 'auto-spawn')
    .sort((a, b) =>
      (topicListWarmPriority(a) - topicListWarmPriority(b)) ||
      (chatActivity(b) - chatActivity(a)),
    )
  const important = candidates
    .filter(shouldAlwaysWarmTopicList)
    .slice(0, IMPORTANT_TOPIC_LIST_WARM_LIMIT)
  const selected = new Map<string, T>()
  for (const chat of important) selected.set(chat.id, chat)
  for (const chat of candidates) {
    if (selected.size >= Math.max(BASE_TOPIC_LIST_WARM_LIMIT, important.length)) break
    selected.set(chat.id, chat)
  }
  return Array.from(selected.values())
}
